const Onboarding = () => {
  return <div>Onboarding</div>;
};

export default Onboarding;
